import { render, staticRenderFns } from "./TableRepresentation.vue?vue&type=template&id=80cdbe90"
import script from "./TableRepresentation.vue?vue&type=script&lang=js"
export * from "./TableRepresentation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports